const SENSITIVE_QUERY_KEYS = [
  'apikey',
  'access_token',
  'token',
  'auth',
  'authorization',
  'refresh_token',
  'jwt',
  'key'
];

const REDACTED = '[REDACTED]';

const sanitizeString = (value) => {
  if (typeof value !== 'string' || value.length === 0) {
    return value;
  }

  let sanitized = value;

  for (const queryKey of SENSITIVE_QUERY_KEYS) {
    const pattern = new RegExp(`([?&]${queryKey}=)([^&\\s]+)`, 'gi');
    sanitized = sanitized.replace(pattern, `$1${REDACTED}`);
  }

  return sanitized;
};

const sanitizeArg = (arg) => {
  if (typeof arg === 'string') {
    return sanitizeString(arg);
  }

  if (arg instanceof Error) {
    const sanitizedError = new Error(sanitizeString(arg.message));
    sanitizedError.name = arg.name;
    sanitizedError.stack = sanitizeString(arg.stack || '');
    return sanitizedError;
  }

  return arg;
};

let patched = false;

export const installSafeConsole = () => {
  if (patched || typeof window === 'undefined' || typeof console === 'undefined') {
    return;
  }

  patched = true;

  const methods = ['log', 'warn', 'error', 'info', 'debug'];

  methods.forEach((method) => {
    const originalMethod = console[method];
    if (typeof originalMethod !== 'function') {
      return;
    }

    console[method] = (...args) => {
      const sanitizedArgs = args.map(sanitizeArg);
      originalMethod.apply(console, sanitizedArgs);
    };
  });
};